import { ChcekboxOption } from ".";

const data = [
  { name: "FLEX Allowance" },
  { name: "Transportation" },
  { name: "Over-the-Counter Allowance" },
  { name: "Part B Rebate" },
  { name: "Groceries" },
  { name: "Caregiver Support" },
];

const AdditionalBenefitsCheckBox = ({
  filtersArray,
  setActuallFilters,
}: {
  filtersArray: string[];
  setActuallFilters: (arr: string[]) => void;
}) => {
  const dataLength = data.length;
  const halfLength = Math.ceil(dataLength / 2);
  const firstHalfData = data.slice(0, halfLength);
  const secondHalfData = data.slice(halfLength);

  return (
    <div className="grid-x small-12 medium-6">
      <div className="cell small-12" style={{ padding: "24px 0 10px" }}>
        <h4 style={{ fontSize: "18px" }}>Additional Benefits</h4>
      </div>
      <div className="cell small-12 medium-6">
        <div className="grid-y">
          {firstHalfData.map((option, index) => (
            <ChcekboxOption
              key={index}
              option={option}
              filtersArray={filtersArray}
              setActuallFilters={setActuallFilters}
            />
          ))}
        </div>
      </div>
      <div className="cell small-12 medium-6">
        <div className="grid-y">
          {secondHalfData.map((option, index) => (
            <ChcekboxOption
              key={index}
              option={option}
              filtersArray={filtersArray}
              setActuallFilters={setActuallFilters}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdditionalBenefitsCheckBox;
